import React from 'react';
import PropTypes from 'prop-types';
import UniversalContainer from '../universal-container/universal-container';
import UniversalText from '../universal-text/universal-text';

function getFormattedCurrentDate() {
  const date = new Date();
  const formattedDate = date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  return formattedDate;
}

const CurrentDate = ({ currentDate, ...rest }) => {
  const label = currentDate?.label || rest.label;
  const container = currentDate?.container || rest.container;
  const text = {
    ...label,
    text: `${label.text} ${getFormattedCurrentDate()}`,
  };

  return (
    <UniversalContainer {...container}>
      <UniversalText {...text} />
    </UniversalContainer>
  );
};

CurrentDate.propTypes = {
  container: UniversalContainer.propTypes,
  label: UniversalText.propTypes,
  currentDate: PropTypes.object,
};

CurrentDate.defaultProps = {
  label: {
    text: `Updated: `,
    textType: 'text',
  },
};

CurrentDate.displayName = 'CurrentDate';
// "fieldName" should keep empty so we can detect whether or not we are inside a grid
CurrentDate.getEditingConfig = (componentDocument, fieldName = '') => {
  const getInputName = (name, topLevel = false) => {
    if (topLevel) {
      // Dumps the last "fieldName" segment ( stringTextAreaSpec, boolCheckboxSpec,
      // stringInputSpec weirdly get an extra "fieldName" segment, placing the input
      // value incorrectly in the "componentDocument" object.
      return `${fieldName?.split('.').at(-1)}.${name}`;
    }
    // if fieldName is filled it means we are inside a grid, so we need the entire
    // fieldName
    if (fieldName) {
      return `${fieldName}.${name}`;
    }
    return name;
  };

  return [
    ...UniversalContainer.getEditingConfig(
      componentDocument,
      'Container',
      [
        'backgroundColor',
        'backgroundImage',
        'border',
        'margin',
        'padding',
        'hide',
        'jumpLinkId',
      ],
      `${getInputName('container')}`
    ),
    ...UniversalText.getEditingConfig(
      componentDocument,
      'Text',
      [
        'fontWeight',
        'groupButton',
        'margin',
        'padding',
        'fontFamily',
        'textColor',
        'textSize',
        'textType',
      ],
      `${getInputName('label')}`
    ),
  ];
};

export default CurrentDate;
